import React, { useState } from 'react';

const translations = {
  ar: {
    title: "الأسئلة الشائعة",
    faqs: [
      { q: "ما هي أنواع الأجهزة الطبية و المعدات التقنية التي تقبلونها?", a: "نحن نقبل نطاقاً واسعاً يشمل أجهزة التصوير الطبي (MRI, X-Ray)، وأجهزة المختبرات، وكافة معدات تقنية المعلومات والاتصالات، وصولاً إلى البطاريات الصناعية ووحدات الطاقة المعقدة" },
      { q: "كيف تضمنون أمن البيانات الحساسة الموجودة في الأجهزة؟", a: "نطبق إجراءات معيارية صارمة تشمل التدمير الفيزيائي الآمن كاملاً لكافة وسائط تخزين البيانات في موقع العميل أو منشأتنا، لضمان عدم استعادتها نهائياً وفق معايير النزاهة الفنية، مع إصدار شهادة تدمير رسمية لكل عملية" },
      { q: "هل تمتلك رفاد القدرة على العمل في المواقع النائية أو الحساسة أمنياً؟", a: "نعم، نتميز بمرونة تشغيلية عالية تتيح لنا تنفيذ عمليات التفكيك الميداني في المناطق النائية والظروف الجغرافية القاسية، مع الالتزام بكامل معايير السلامة في المناطق الصناعية الحساسة" },
      { q: "كيف تساعد 'رفاد' العميل في تقليل التكاليف التشغيلية؟", a: "نعمل على تحرير المساحات المهدرة في مخازن العميل عبر التخلص الفوري من الأصول الفائضة، مما يقلل تكاليف الإيجارات، بالإضافة إلى تحويل تلك الأصول إلى قيمة اقتصادية مستدامة" }
    ]
  },
  en: {
    title: "Frequently Asked Questions",
    faqs: [
      { q: "What types of E-Waste, medical devices, and technical materials do you accept?", a: "We accept a wide range including medical imaging (MRI, X-Ray), laboratory equipment, and all IT and telecommunications infrastructure, down to industrial batteries and complex power units" },
      { q: "How do you guarantee the security of sensitive data on the devices?", a: "We apply strict standard procedures including full secure physical destruction of all data storage media at the client's site or our facility, ensuring zero recovery in line with technical integrity standards, with the issuance of an official Certificate of Destruction (CoD) for each process" },
      { q: "Does Rifad have the capacity to operate in remote or high-security sites?", a: "Yes, we feature high operational resilience that allows us to execute on-site dismantling in remote areas and harsh conditions, while adhering to full safety standards in sensitive industrial zones" },
      { q: "How does Rifad help the client reduce operational costs?", a: "We free up wasted space in the client's warehouses by promptly disposing of surplus assets, which reduces rental costs and transforms those assets into sustainable economic value" }
    ]
  }
};

const FAQ = ({ currentLang }) => {
  const t = translations[currentLang] || translations.ar; 
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">{t.title}</h2>
        
        <div className="faq-list">
          {t.faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <button
                className="faq-question-btn"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span className="faq-question-text">{faq.q}</span>
                <span className="faq-icon" aria-hidden="true">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>
              
              <div 
                id={`faq-answer-${index}`}
                className="faq-answer"
                role="region"
                aria-labelledby={`faq-question-${index}`}
              >
                <div className="faq-answer-content">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        /* ========================================= */
        /* Base & Reset                                */
        /* ========================================= */
        .faq-section {
          width: 100%;
          padding: 4rem 1.5rem;
           direction: ${currentLang === 'ar' ? 'rtl' : 'ltr'};
        }

        .faq-container {
          max-width: 900px;
          margin: 0 auto;
        }

        /* ========================================= */
        /* Title Styling                               */
        /* ========================================= */
        .faq-title {
          font-size: clamp(1.75rem, 5vw, 2.5rem);
          font-weight: 800;
          text-align: center;
          color: #1a2a3a;
          margin-bottom: 3rem;
          letter-spacing: -0.02em;
          position: relative;
          padding-bottom: 1rem;
        }

        .faq-title::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #53b096, #3a7b66);
          border-radius: 2px;
        }

        /* ========================================= */
        /* FAQ List                                    */
        /* ========================================= */
        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        /* ========================================= */
        /* FAQ Item                                    */
        /* ========================================= */
        .faq-item {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(8px);
          border-radius: 20px;
          border: 1px solid rgba(83, 176, 150, 0.2);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
        }

        .faq-item:hover {
          border-color: rgba(83, 176, 150, 0.5);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
          transform: translateY(-2px);
        }

        .faq-item.active {
          border-color: #53b096;
          box-shadow: 0 12px 24px rgba(83, 176, 150, 0.15);
        }

        /* ========================================= */
        /* Question Button (Accessible)                */
        /* ========================================= */
        .faq-question-btn {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 1rem;
          padding: 1.2rem 1.8rem;
          background: transparent;
          border: none;
          cursor: pointer;
          font-family: inherit;
          text-align: ${currentLang === 'ar' ? 'right' : 'left'};
          transition: background 0.2s ease;
        }

        .faq-question-btn:hover {
          background: rgba(83, 176, 150, 0.05);
        }

        .faq-question-text {
          font-weight: 700;
          font-size: clamp(1rem, 4vw, 1.1rem);
          line-height: 1.4;
          color: #1a2a3a;
          flex: 1;
        }

        /* ========================================= */
        /* Icon Animation                             */
        /* ========================================= */
        .faq-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #53b096;
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          flex-shrink: 0;
        }

        .faq-item.active .faq-icon {
          transform: rotate(180deg);
        }

        .faq-icon svg {
          display: block;
          width: 20px;
          height: 20px;
        }

        /* ========================================= */
        /* Answer Section (Responsive Height)          */
        /* ========================================= */
        .faq-answer {
          display: grid;
          grid-template-rows: 0fr;
          transition: grid-template-rows 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .faq-item.active .faq-answer {
          grid-template-rows: 1fr;
        }

        .faq-answer-content {
          overflow: hidden;
          padding: 0 1.8rem;
          color: #5a6a7a;
          line-height: 1.7;
          font-size: clamp(0.9rem, 3.5vw, 1rem);
        }

        .faq-item.active .faq-answer-content {
          padding-bottom: 1.5rem;
          padding-top: 0.5rem;
        }

        /* ========================================= */
        /* Responsive Breakpoints                     */
        /* ========================================= */
        
        /* Tablets and small desktops */
        @media (max-width: 768px) {
          .faq-section {
            padding: 3rem 1.2rem;
          }
          
          .faq-question-btn {
            padding: 1rem 1.2rem;
          }
          
          .faq-answer-content {
            padding: 0 1.2rem;
          }
          
          .faq-item.active .faq-answer-content {
            padding-bottom: 1.2rem;
          }
        }

        /* Mobile Devices */
        @media (max-width: 480px) {
          .faq-section {
            padding: 2rem 1rem;
          }
          
          .faq-title {
            margin-bottom: 2rem;
          }
          
          .faq-question-btn {
            padding: 0.9rem 1rem;
            gap: 0.75rem;
          }
          
          .faq-question-text {
            font-size: 0.95rem;
          }
          
          .faq-answer-content {
            padding: 0 1rem;
            font-size: 0.85rem;
            line-height: 1.6;
          }
          
          .faq-item.active .faq-answer-content {
            padding-bottom: 1rem;
          }
          
          .faq-icon svg {
            width: 18px;
            height: 18px;
          }
        }

        /* Large Screens (>= 1440px) */
        @media (min-width: 1440px) {
          .faq-section {
            padding: 6rem 2rem;
          }
          
          .faq-container {
            max-width: 1100px;
          }
          
          .faq-question-btn {
            padding: 1.5rem 2rem;
          }
          
          .faq-question-text {
            font-size: 1.2rem;
          }
          
          .faq-answer-content {
            padding: 0 2rem;
            font-size: 1.05rem;
          }
          
          .faq-item.active .faq-answer-content {
            padding-bottom: 1.8rem;
            padding-top: 0.8rem;
          }
        }

        /* Reduced motion preference */
        @media (prefers-reduced-motion: reduce) {
          .faq-item,
          .faq-icon,
          .faq-answer {
            transition: none;
          }
          
          .faq-question-btn:hover {
            background: transparent;
          }
          
          .faq-item:hover {
            transform: none;
          }
        }
      `}</style>
    </section>
  );
};

export default FAQ;